export const orchestrationPathResources = {
    journeys: "journeys",
    campaigns: "campaigns",
    ivrs: "ivrs",
    routing: "routing-rules",
    customFunctions: "regal-functions",
} as const;
